import styled from 'styled-components'

export const CenteredStateStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.space.small};
  text-align: center;
`

export const EmptyStateStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.space.xsmall};
  text-align: center;
`

export const EmptyStateBubbleStyled = styled.div`
  width: ${(props) => props.theme.typography.pxToRem(72)};
  height: ${(props) => props.theme.typography.pxToRem(72)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(props) => props.theme.typography.pxToRem(12)};
  background: ${(props) => props.theme.colors.content.mainBackground};
`
